import { post } from "@/utils/utils";
// 导购相关接口
const fortunellaVenosa = {
  state: {},
  mutations: {
    ADD_STORE_BEAN_RULE() {},
    STORE_BEAN_RULE_PAGE() {},
    EDIT_STORE_BEAN_RULE() {},
    ADD_STORE_BEAN_SEND() {},
    STORE_GOLD_BEAN_SEND() {},
    STORE_GOLD_BEAN_SEND_DETAILS() {},
    EDIT_STORE_GOLD_BEAN_SEND() {},
    EDIT_STORE_GOLD_BEAN_SEND_INVALID() {},
    STORE_GOLD_BEAN_SEND_HISTORY() {}
  },
  actions: {
    addStoreGoldBeanRule({ commit }, params) {
      return post({
        commit,
        url: `/store/storeGoldBeanRule/add`,
        name: "ADD_STORE_BEAN_RULE",
        params
      });
    },
    storeGoldBeanRulePage({ commit }, params) {
      return post({
        commit,
        url: `/store/storeGoldBeanRule/page`,
        name: "STORE_BEAN_RULE_PAGE",
        params
      });
    },
    editStoreGoldBeanRule({ commit }, params) {
      return post({
        commit,
        url: `/store/storeGoldBeanRule/edit`,
        name: "EDIT_STORE_BEAN_RULE",
        params
      });
    },
    addStoreBeanSend({ commit }, params) {
      return post({
        commit,
        url: `/store/storeGoldBeanSend/add`,
        name: "ADD_STORE_BEAN_SEND",
        params
      });
    },
    storeGoldBeanSendList({ commit }, params) {
      return post({
        commit,
        url: `/store/storeGoldBeanSend/page`,
        name: "STORE_GOLD_BEAN_SEND",
        params
      });
    },
    storeGoldBeanSendDetails({ commit }, params) {
      return post({
        commit,
        url: `/store/storeGoldBeanSend/queryById`,
        name: "STORE_GOLD_BEAN_SEND_DETAILS",
        params
      });
    },
    editStoreGoldBeanSend({ commit }, params) {
      return post({
        commit,
        url: `/store/storeGoldBeanSend/edit`,
        name: "EDIT_STORE_GOLD_BEAN_SEND",
        params
      });
    },
    editStoreGoldBeanSendInvalid({ commit }, params) {
      return post({
        commit,
        url: `/store/storeGoldBeanSend/invalid`,
        name: "EDIT_STORE_GOLD_BEAN_SEND_INVALID",
        params
      });
    },
    storeGoldBeanSendHistory({ commit }, params) {
      return post({
        commit,
        url: `/store/storeGoldBeanSend/querySpecialRecord`,
        name: "STORE_GOLD_BEAN_SEND_HISTORY",
        params
      });
    }
  }
};

export default fortunellaVenosa;
